import { useQuery } from "@tanstack/react-query";
import apiFetch from "../../utils/apiFetch";
import { authHeaders } from "./helpers";
import type { T4PreviewData } from "./types";

export function useT4Preview(year: number) {
  return useQuery<T4PreviewData>({
    queryKey: ["t4-preview", year],
    queryFn: async () => {
      const r = await apiFetch(
        "/api/v1/payroll/taxes/t4-preview?year=" + year,
        { headers: authHeaders() }
      );
      if (!r.ok) throw new Error("HTTP " + r.status);
      return (await r.json()) as T4PreviewData;
    },
    enabled: !!year,
    refetchOnWindowFocus: false,
  });
}